import { IViewerMode } from '../../models/IViewMode';
import { store } from '../../store/store';

export const getViewerModeSettingsFromStore = () => {
  const state = store.getState();
  const viewerModeSettings = state.ViewerModeReducer as IViewerMode;
  return viewerModeSettings;
};
